import Service from "../../services";
import Swal from "sweetalert2";

const communityModule = {
  namespaced: true,
  communityDetail: {},
  state: {
    select_comunity: {
      name: "",
      address: "",
      subdistrict: {
        name: "",
      },
      district: {
        name: "",
      },
      province: {
        name: "",
      },
      description: "",
    },
    list_community: [],
  },
  mutations: {
    SET_COMMUNITY(state, data) {
      data.image_url = JSON.parse(data.image_url);
      state.select_comunity = data;
    },
    SET_COMMUNITY_LIST(state, data) {
      let first = {
        community_id: null,
        name: "ทุกชุมชน",
      };
      data.unshift(first);
      state.list_community = data;
    },
  },
  actions: {
    onGetCommunity({ commit }, data) {
      return Service.CommunityAPI.getCommunity(data).then((res) => {
        if (res.code == 200) {
          commit("SET_COMMUNITY", res.result);
          return res.code;
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
          });
        }
      });
    },
    onGetCommunityList({ commit }) {
      return Service.CommunityAPI.listCommunity().then((res) => {
        if (res.code == 200) {
          commit("SET_COMMUNITY_LIST", res.result);
          return res;
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
          });
        }
      });
    },
    onStoreCommunityProgress({ commit }, data) {
      return Service.CommunityAPI.storeCommunityProgress(data).then((res) => {
        if (res.code == 200) {
          Swal.fire({
            icon: "success",
            title: "เรียบร้อย!",
          });
          return res.code;
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
          });
        }
      });
    },
    onStoreCommunity({ commit }, data) {
      return Service.CommunityAPI.storeCommunity(data).then((res) => {
        if (res.code == 200) {
          Swal.fire({
            icon: "success",
            title: "เรียบร้อย!",
          });
          return res.code;
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
          });
        }
      });
    },
    onStoreCommunityProject({ commit }, data) {
      return Service.CommunityAPI.storeCommunityProject(data).then((res) => {
        if (res.code == 200) {
          Swal.fire({
            icon: "success",
            title: "เรียบร้อย!",
          });
          return res.code;
        } else {
          Swal.fire({
            icon: "error",
            title: "ผิดพลาด!",
          });
        }
      });
    },
  },
};

export default communityModule;
